/*
  itemsの参照をまとめてimportしてたときにエラーになるのでimportは分割する
  extendsを多重にする、循環させる、このあたりが原因か？
*/
import { PaintStyle } from "../../drawing";
import { BarcodeValueItem } from "./BarcodeValueItem";
import { IPaintableOnEditing } from "./IPaintableOnEditing";
import { AbstractRectangleItem } from "./AbstractRectangleItem";
import { TypeKeys } from "./TypeKeys";
import { IBarcodeItemBean } from "../../../infrastructure/document/ver2/beans/items";

export class BarcodeItem extends AbstractRectangleItem implements IPaintableOnEditing {
  constructor() {
    super(TypeKeys.BarcodeItem);
  }

  public name: string = "";
  public value: string; // v1では常に空文字が入っているらしい。バックエンドからも空文字が与えられる。
  public items: BarcodeValueItem[];
  public separator: string;
  public origin: IBarcodeItemBean; // バックエンド側に受け取ったオブジェクトをそのまま返すため保持
  public paintStyle: PaintStyle = new PaintStyle();
  public paintStyleOnEditing: PaintStyle = null;
 
  protected createCloneInstance(): BarcodeItem {
    return new BarcodeItem();
  }

  protected applyMembers(clone: BarcodeItem): void {
    super.applyMembers(clone);
    clone.name = this.cloneValue(this.name);
    clone.value = this.cloneValue(this.value);
    clone.items = this.cloneValue(this.items);
    clone.separator = this.cloneValue(this.separator);
    clone.origin = this.cloneValue(this.origin);
    clone.paintStyle = this.cloneValue(this.paintStyle);
    clone.paintStyleOnEditing = this.cloneValue(this.paintStyleOnEditing);
  }
}
